import { d as s, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as c, normalizeClass as l, normalizeStyle as n, createElementVNode as r } from "vue";
const a = s("message"), i = /* @__PURE__ */ r("path", {
  d: "M879.59 1024c-5.252 0-13.128 0-18.38-2.626L706.297 981.99c-13.128 5.251-21.005 7.877-28.882 10.502-52.512 18.38-107.65 26.257-165.415 26.257C228.43 1021.374 0 792.944 0 509.374S228.43 0 512 0s512 228.43 512 509.374c0 84.02-21.005 170.667-63.015 244.185-2.626 7.877-10.503 15.754-18.38 28.882l15.754 152.287c2.626 21.005-5.251 42.01-18.38 57.764-13.128 15.754-31.507 26.257-55.138 28.882 0 2.626-2.626 2.626-5.251 2.626zm-165.416-44.636zm-10.502-76.143c5.251 0 7.877 0 13.128 2.625l162.79 39.385-13.128-162.79c0-10.503 2.625-23.63 7.876-34.133 7.877-13.129 15.754-23.631 18.38-31.508 34.133-63.015 52.513-133.908 52.513-207.426C945.23 273.067 750.933 78.77 512 78.77S78.77 273.067 78.77 509.374C78.77 748.308 273.066 939.98 512 939.98c47.262 0 94.523-7.876 139.159-23.63 7.877-2.626 18.38-7.877 31.508-13.128 7.877 2.625 13.128 0 21.005 0zM512 735.179c-39.385 0-78.77-13.128-105.026-36.758-15.753-13.129-18.38-39.385-2.625-55.139 13.128-15.754 39.384-18.38 55.138-2.626 23.63 21.006 81.395 21.006 105.026 0 15.754-13.128 42.01-13.128 55.138 5.252 13.128 15.754 13.128 42.01-5.251 55.138-23.63 21.005-63.015 34.133-102.4 34.133z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), m = [
  i
];
function p(e, _, d, f, g, u) {
  return t(), c("svg", {
    class: l(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, m, 6);
}
const h = /* @__PURE__ */ o(a, [["render", p]]);
export {
  h as default
};
